import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle2, Loader2, ArrowRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SponsorThanksPage() {
  const { eventId } = useParams();
  const [params] = useSearchParams();
  const sponsorshipId = params.get('sponsorship_id');
  const [status, setStatus] = useState('pending');
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!sponsorshipId) return;
    let mounted = true;
    let attempts = 0;
    const tick = async () => {
      try {
        const res = await axios.get(`${API}/sponsorship/${sponsorshipId}/confirm`);
        if (!mounted) return;
        setData(res.data);
        if (res.data.status === 'paid') setStatus('paid');
        else if (attempts < 8) { attempts += 1; setTimeout(tick, 1500); }
        else setStatus('pending');
      } catch (e) {
        if (attempts < 5) { attempts += 1; setTimeout(tick, 1500); }
      }
    };
    tick();
    return () => { mounted = false; };
  }, [sponsorshipId]);

  return (
    <div className="min-h-screen bg-background pt-20 pb-20" data-testid="sponsor-thanks-page">
      <div className="max-w-md mx-auto px-4 sm:px-6 text-center">
        <Card className="border-emerald-500/30 bg-emerald-500/5">
          <CardContent className="p-8 space-y-3">
            {status === 'paid' ? <CheckCircle2 className="h-12 w-12 text-emerald-500 mx-auto" /> : <Loader2 className="h-12 w-12 text-emerald-500 mx-auto animate-spin" />}
            <h1 className="text-2xl font-bold">{status === 'paid' ? 'You’re officially a sponsor!' : 'Confirming your payment…'}</h1>
            <p className="text-sm text-muted-foreground">
              {status === 'paid'
                ? `Your ${data?.tier === 'swag_bag' ? 'Swag Bag' : 'Logo Soup'} sponsorship is live. We just emailed you the receipt.`
                : 'Hang tight while Stripe finalises the charge.'}
            </p>
            <div className="pt-3 flex flex-col gap-2">
              <Link to={`/swag-bag/${eventId}`}><Button className="w-full bg-indigo-600 hover:bg-indigo-700 text-white">View the Swag Bag <ArrowRight className="h-4 w-4 ml-1" /></Button></Link>
              <Link to="/events"><Button variant="outline" className="w-full">Back to events</Button></Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
